module.exports = __webpack_public_path__ + "static/media/light-bulb.5adc453b.svg";